import React from "react";
import styled from "styled-components";
import cx from "classnames";
import { colors } from "core/stylesheet";

const Wrap = styled.button`
  ${({ color = "brand" }) => `
    background-color: ${colors[color]};
    border-radius: 100px;
  border: 2px solid #000;
  font-family:CircularStd-Book, sans-serif;
  text-decoration: none;
  color: #000000;
  padding: 10px 23px;
  &:hover {
    color : white;
  }
  `} ${({ size }) => ``} &:disabled {
    cursor: not-allowed;
    background-color: ${colors.gray};
    border-radius: 100px;
    border: 2px solid #000;
    text-decoration: none;
    color: #000000;
    padding: 10px 23px;
  }
  ${({ finalize }) =>
    finalize &&
    `
    @media (max-width: 680px) {
      border-radius: unset;
      width: 100%;
      text-align: center;
      background: #000;
      color: #fff;
      height: 60px;
      margin-top: 10.5rem;
    }
  `};
`;

const sizes = {
  normal: "ph4 pv3 f5",
  small: "ph3 pv2 f5 f6",
  responsive: "ph3 pv2 f5 f5 ph3-ns pv2-ns f6-ns",
  large: "w-80 ph3 pv2 f5 f5 ph3-ns pv2-ns f6-ns"
};

export default ({
  type,
  children,
  disabled,
  color,
  size = "normal",
  onClick,
  finalize
}) => (
  <Wrap
    finalize={finalize}
    onClick={onClick}
    type={type}
    color={color}
    size={size}
    className={cx(
      "btn input-reset white link pointer fw6 dib b--none br1 hover-bg-black",
      sizes[size]
    )}
    disabled={disabled}
  >
    {children}
  </Wrap>
);



// WEBPACK FOOTER //
// ./src/components/generic/kit/Button/index.js